import { useState, useCallback } from 'react';
import { apiClient } from '../api/client';

export interface AuditLogItem {
  id: string;
  organization_id: string;
  user_id: string;
  credential_id?: string;
  action: string;
  ip_address?: string;
  user_agent?: string;
  metadata_log: Record<string, any>;
  created_at: string;
}

export function useAudit() {
  const [logs, setLogs] = useState<AuditLogItem[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchLogs = useCallback(async (filters?: { user_id?: string; credential_id?: string; start_date?: string; end_date?: string }) => {
    setIsLoading(true);
    setError(null);
    try {
      let query = '';
      if (filters) {
        const params = new URLSearchParams();
        if (filters.user_id) params.append('user_id', filters.user_id);
        if (filters.credential_id) params.append('credential_id', filters.credential_id);
        if (filters.start_date) params.append('start_date', filters.start_date);
        if (filters.end_date) params.append('end_date', filters.end_date);
        query = `?${params.toString()}`;
      }
      
      const data = await apiClient.get<AuditLogItem[]>(`/audit/logs${query}`);
      setLogs(data);
    } catch (err: any) {
      setError(err.message || 'Erro ao carregar logs');
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { logs, isLoading, error, fetchLogs };
}
